@import "../../../3d-party/prism/prism";
@import "../../../3d-party/prism/prism-line-numbers";
@import "../../../globalStyles/commons";


:host {
  display: block;
  height: 100%;

  /**
    * @prop --goat-code-highlighter-background: Code Highlighter background color
    */
  --goat-code-highlighter-background: var(--code-bg-primary);
}

.code-loader {
  height: 10rem;
  background-color: var(--goat-code-highlighter-background);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--spacing-02);
}

.code-highlighter {
  position: relative;
  height: 100%;
  background-color: var(--goat-code-highlighter-background);
  color: var(--text-primary);
  .scroll-wrapper {
    height: 100%;
    overflow: auto;

    .line-numbers-wrapper {
      padding: var(--spacing-05);
      padding-inline-end: 3rem;
      position: relative;
      @include font-style(code-02);

      &.line-numbers {
        margin-left: 3.8rem;
      }

      .highlighter {
        margin: 0;
        position: relative;
      }
    }
  }

  .copy-btn {
    position: absolute;
    background-color: var(--goat-code-highlighter-background);
    top: 0.675rem;
    right: var(--spacing-03);
  }
}

:host([inline]) {
  display: inline;
  height: initial;
  .code-highlighter {
    display: inline;
    cursor: pointer;
    .scroll-wrapper {
      display: inline;
      .line-numbers-wrapper {
        padding: 0 var(--spacing-03);
        font-size: inherit;
        display: inline;
        word-wrap: break-word;
        .highlighter {
          display: inline;
        }
      }
    }
  }
  .code-loader {
    height: initial;
    display: inline;
  }
}
